import { Link, useNavigate } from 'react-router-dom';
import BrandMark from '../components/BrandMark';
import GradientPill from '../components/GradientPill';
import RepTrophy from '../components/RepTrophy';
import { useAuth } from '../context/AuthContext';

// First-touch screen after sign-up. Celebrates with a trophy and
// routes the user into onboarding (or straight to the app if they've
// already seen it).
export default function WelcomePage() {
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: '100vh',
      display: 'grid', placeItems: 'center',
      padding: 24,
      textAlign: 'center',
      background:
        'radial-gradient(circle at 0% 0%, rgba(255,62,127,.20), transparent 35%),' +
        'radial-gradient(circle at 100% 100%, rgba(91,233,255,.14), transparent 40%),' +
        'var(--bg)'
    }}>
      <div style={{ maxWidth: 460 }}>
        <BrandMark size={32} />
        <div style={{ margin: '24px auto', display: 'grid', placeItems: 'center' }}>
          <RepTrophy value={0} size={120} />
        </div>
        <p className="eyebrow" style={{ color: 'var(--primary)' }}>WELCOME</p>
        <h1 className="h1" style={{ fontSize: 36, marginTop: 8 }}>You're in, {user?.displayName?.split(' ')[0] || user?.username}.</h1>
        <p style={{ color: 'var(--text-dim)', fontSize: 17, marginTop: 12, lineHeight: 1.55 }}>
          Your first tier is <strong style={{ color: 'var(--text)' }}>Rookie Frame</strong>. Drop a post and tap Challenge on someone to start climbing.
        </p>
        <div className="row" style={{ gap: 10, justifyContent: 'center', marginTop: 26, flexWrap: 'wrap' }}>
          <GradientPill label="Take the tour" onClick={() => navigate('/onboarding')} size="lg" />
          <Link to="/app" className="btn btn-ghost btn-lg">Skip to the app</Link>
        </div>
      </div>
    </div>
  );
}
